import gql from 'graphql-tag'

export default gql`mutation ($id: Int!, $approve: Boolean!, $reason: String){
  approveRejectAnnualLeave(id: $id, approve: $approve, reason: $reason){
    id
    start_date
    start_of_day
    end_date
    end_of_day
    status_id
    status{
      id
      description
    }
    status_changed_by_user{
      user_id
      first_name
      last_name
    }
    status_change_date
    reason
    date_cancelled
  }
}`